import { IconButton, Typography } from '@mui/material';
import React, { FC } from 'react';
import { smallButtonStyle } from '@efacity/frontend-shared';
import DeleteIcon from '@mui/icons-material/DeleteForever';

export interface CenterNameWithDeleteButtonProps {
  userId: string;
  userFullName: string;
  centerId: string;
  centerName: string;
  onDeleteCenterAdminCLick: (orgId: string, userId: string, userFullName: string) => void;
}

const CenterNameWithDeleteButton: FC<CenterNameWithDeleteButtonProps> = ({
  userId,
  userFullName,
  centerId,
  centerName,
  onDeleteCenterAdminCLick
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography color="primary" key={`centerIdKey${centerId}`}>
        {centerName}
      </Typography>
      <div>
        <IconButton
          color="primary"
          aria-label="delete-instructor"
          data-testid="delete-admin-btn"
          component="span"
          style={smallButtonStyle}
          onClick={() => onDeleteCenterAdminCLick(centerId, userId, userFullName)}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default CenterNameWithDeleteButton;
